import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { AgmCoreModule } from '@agm/core';

import { FuseSharedModule } from '@fuse/shared.module';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { BannerComponent } from './banner-list/banner-list.component';
import { BannerEntryComponent } from './banner-entry/banner-entry.component';
import { BannerService } from './banner.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';


const routes = [
  {
      path     : 'banner',
      component: BannerComponent
  },
  {
    path     : 'banner/add',
    component: BannerEntryComponent
  },
  {
    path: 'banner/edit/:id',
    component: BannerEntryComponent
  }
];
@NgModule({
  
  declarations: [
    BannerComponent,
    BannerEntryComponent   
  ],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatPaginatorModule,
    MatSnackBarModule,
    MatTableModule,
    MatTabsModule,
    AgmCoreModule.forRoot({
        apiKey: 'AIzaSyD81ecsCj4yYpcXSLFcYU97PvRsE_X8Bx8'
    }),
    RouterModule.forChild(routes),
    TranslateModule,
    FuseSharedModule,
    DragDropModule,
    MatProgressSpinnerModule,
    NgxSkeletonLoaderModule
   
  ],
  providers:[
    BannerService     
  ]
  
})
export class BannerModule { }
